import { tm } from '@captaincause/ui/tm'

const DIRECTION_CLASS_NAMES = [
  'left-[-75px] top-[15px] rotate-[-25deg] md:left-[-50px] md:top-[25px]',
  'right-[-75px] top-[15px] rotate-[25deg] md:right-[-50px] md:top-[25px]',
  'bottom-[15px] left-[-75px] rotate-[25deg] md:bottom-[25px] md:left-[-50px]',
  'bottom-[15px] right-[-75px] rotate-[-25deg] md:bottom-[25px] md:right-[-50px]',
]

function PreviewBand({ className = '' }: { className?: string }) {
  return (
    <div
      className={tm(
        'fixed z-[9999] flex w-[250px] items-center justify-center border border-dark-orange bg-orange text-sm font-semibold text-black shadow-md md:text-xl',
        className,
      )}
    >
      Preview
    </div>
  )
}

export function PreviewDoodle() {
  return (
    <>
      {DIRECTION_CLASS_NAMES.map(className => (
        <PreviewBand key={className} className={className} />
      ))}
    </>
  )
}
